import { Icon, Text, VStack } from '@revolut-internal/ui-kit'
import { FC } from 'react'

export const NoMessageSelectedWidget: FC = () => (
  <VStack align="center">
    <Icon name="Chat" size={104} />

    <Text mt="s-16" variant="emphasis1">
      Select message to review prompt
    </Text>
    <Text mt="s-8" textAlign="center" variant="body2">
      To get started, select a message on the left and the prompt will be displayed here.
      You can edit and regenerate responses.
    </Text>
  </VStack>
)
